/* eslint-disable @typescript-eslint/naming-convention */

import BodyTypeFilter from './Components/BodyTypeFilter/BodyTypeFilter';
import { ColorFilter } from './Components/ColorFilter/ColorFilter';
import { ConsumptionFilter } from './Components/ConsumptionFilter/ConsumptionFilter';
import { DoorsFilter } from './Components/DoorsFilter/DoorsFilter';
import { EngineSizeFilter } from './Components/EngineSizeFilter/EngineSizeFilter';
import { EnvCertificateFilter } from './Components/EnvCertificateFilter/EnvCertificateFilter';
import { EvRangeFilter } from './Components/EvRangeFilter/EvRangeFilter';
import { FuelFilter } from './Components/FuelFilter/FuelFilter';
import { GearboxFilter } from './Components/GearboxFilter/GearboxFilter';
import { IncludeSold } from './Components/IncludeSold/IncludeSold';
import { LocationFilter } from './Components/LocationFilter/LocationFilter';
import { LocationFilterUk } from './Components/LocationFilter/LocationFilterUk';
import MakeFilter from './Components/MakeFilter/MakeFilter';
import { MileageFilter } from './Components/MileageFilter/MileageFilter';
import ModelFilter from './Components/ModelFilter/ModelFilter';
import ModelVariantFilter from './Components/ModelVariantFilter/ModelVariantFilter';
import { PowerFilter } from './Components/PowerFilter/PowerFilter';
import { PriceFilter } from './Components/PriceFilter/PriceFilter';
import { SeatsFilter } from './Components/SeatsFilter/SeatsFilter';
import { ShowOnly } from './Components/ShowOnly/ShowOnly';
import { getEnabledToggleConfig } from './Components/ShowOnly/ShowOnly.utils';
import { YearFilter } from './Components/YearFilter/YearFilter';

import { FilterCategories, FilterControlBaseProps } from './FilterPanel.entity';

const FILTER_CATEGORIES: FilterCategories = [
  {
    id: 'location',
    isMainFilter: true,
    restrictLocales: ['uk'],
    defaultOpen: true,
    Component: ({ ...args }: FilterControlBaseProps) => <LocationFilterUk {...args} />,
  },
  {
    id: 'location',
    defaultOpen: true,
    isMainFilter: true,
    restrictLocales: ['fr', 'de'],
    Component: ({ ...args }: FilterControlBaseProps) => <LocationFilter {...args} />,
  },
  {
    id: 'promotions_exclusives',
    isMainFilter: true,
    defaultOpen: true,
    restrictLocales: ['fr'],
    Component: () => null,
  },
  {
    id: 'buyOnlineExp',
    isMainFilter: true,
    defaultOpen: true,
    restrictLocales: ['uk', 'de'],
    Component: () => null,
  },
  {
    id: 'price',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <PriceFilter {...args} />,
  },
  {
    id: 'make',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <MakeFilter {...args} />,
  },
  {
    id: 'model',
    isMainFilter: true,
    parentId: 'make',
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <ModelFilter {...args} />,
  },
  {
    id: 'variant-type',
    isMainFilter: true,
    parentId: 'model',
    defaultOpen: false,
    restrictLocales: ['uk'],
    Component: ({ ...args }: FilterControlBaseProps) => <ModelVariantFilter {...args} />,
  },
  {
    id: 'fuelType',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <FuelFilter {...args} />,
  },
  {
    id: 'evWltpRange',
    isMainFilter: true,
    defaultOpen: false,
    restrictLocales: ['fr'],
    Component: ({ ...args }: FilterControlBaseProps) => <EvRangeFilter {...args} />,
  },
  {
    id: 'year',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <YearFilter {...args} />,
  },
  {
    id: 'mileage',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <MileageFilter {...args} />,
  },
  {
    id: 'fuel-consumption',
    isMainFilter: true,
    defaultOpen: false,
    restrictLocales: ['de'],
    Component: ({ ...args }: FilterControlBaseProps) => <ConsumptionFilter {...args} />,
  },
  {
    id: 'gearBox',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <GearboxFilter {...args} />,
  },
  {
    id: 'color',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <ColorFilter {...args} />,
  },
  {
    id: 'doors',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <DoorsFilter {...args} />,
  },
  {
    id: 'seats',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <SeatsFilter {...args} />,
  },
  {
    id: 'bodyType',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <BodyTypeFilter {...args} />,
  },
  {
    id: 'engineSize',
    isMainFilter: false,
    defaultOpen: false,
    restrictLocales: ['uk'],
    Component: ({ ...args }: FilterControlBaseProps) => <EngineSizeFilter {...args} />,
  },
  {
    id: 'enginePower',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <PowerFilter {...args} />,
  },
  {
    id: 'emissionSticker',
    isMainFilter: false,
    defaultOpen: false,
    restrictLocales: ['fr'],
    Component: ({ ...args }: FilterControlBaseProps) => <EnvCertificateFilter {...args} />,
  },
  {
    id: 'showOnly',
    isMainFilter: false,
    defaultOpen: true,
    Component: ({ ...args }: FilterControlBaseProps) => <ShowOnly {...args} />,
    getIsHidden: props => {
      const toggleConfig = getEnabledToggleConfig(props);
      const hasActiveToggles = Object.keys(toggleConfig).some(
        toggleKey => toggleConfig[toggleKey as keyof typeof toggleConfig],
      );
      return !hasActiveToggles;
    },
  },
  {
    id: 'includeSold',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <IncludeSold {...args} />,
  },
];

export { FILTER_CATEGORIES };
